import { useAPIV2 } from "../../../yoello-lib/modules/API2/useAPIv2";
import APIExtensions from "../../../yoello-lib/modules/API2/APIDefs";
import ITimeZone from "../../../interfaces/ITimeZone";

/**API calls for startup data all calls should just save into redux */
export function useStartupData() {

    useAPIV2(APIExtensions.currencies, { doNotCacheValue: true });
    useAPIV2(APIExtensions.language, {});
    useAPIV2<ITimeZone[]>(APIExtensions.timezones, {});
    useAPIV2(APIExtensions.venueTypes, {});
    useAPIV2<any>(APIExtensions.feePlans, {});
}